import React from 'react';

import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const EventMediaForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        images: page.images,
      }}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync({
          images: values.images,
        });

        return {
          data,
          error,
        };
      }}
      fields={[
        {
          name: 'images',
          type: 'images',
        },
      ]}
    />
  );
};

export default EventMediaForm;
